export enum URISchemeTypes {
  "Custom" = 0,
  "Client" = 1,
  "Development" = 2,
  "PLAccount" = 3,
  "Estimate" = 4,
  "ProposedWork" = 5,
  "JobInstruction" = 6,
}
